import { ReadonlyRepositoryListService, Result } from '@softline/core';
import { computed, inject, Injectable } from '@angular/core';
import { LieferantenQuery } from '../types/lieferanten-query';
import { LieferantenProduktgruppeRepository } from '../repositories/lieferanten-produktgruppe.repository';
import { SupplierProductGroup } from '../types/supplier-product-group';
import { SupplierIdService } from './supplier-id.service';

@Injectable()
export class LieferantenProduktgruppeService extends ReadonlyRepositoryListService<
  SupplierProductGroup,
  Result<SupplierProductGroup[]>,
  LieferantenQuery
> {
  readonly #supplierIdService = inject(SupplierIdService);

  supplierId = computed(() => this.#supplierIdService.supplierId()());
  override params = computed(() => {
    return { id: this.supplierId() };
  });

  constructor() {
    super(inject(LieferantenProduktgruppeRepository));
  }

  protected override getItems(
    result: Result<SupplierProductGroup[]> | null | undefined
  ): SupplierProductGroup[] {
    return result as any;
  }
}
